import { render, staticRenderFns } from "./NavBarAlternative.vue?vue&type=template&id=7938809c&scoped=true"
import script from "./NavBarAlternative.vue?vue&type=script&lang=js"
export * from "./NavBarAlternative.vue?vue&type=script&lang=js"
import style0 from "./NavBarAlternative.vue?vue&type=style&index=0&id=7938809c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7938809c",
  null
  
)

export default component.exports